import { useEffect, useState } from "react";
import { PageHeader } from "@/components/PageHeader";
import { MasterUpload } from "@/components/MasterList";
import { MasterEntries } from "@/components/master-list/MasterEntries";
import { api } from "@/lib/api";

export default function MasterListPage() {
  const [meta, setMeta] = useState(null);
  const [key, setKey] = useState(0);
  const [tick, setTick] = useState(0);
  useEffect(() => {
    api.get("/master-list", { params: { q: "__none__" } }).then((r) => setMeta(r.data.meta));
  }, [key, tick]);
  return (
    <div data-testid="master-list-page">
      <PageHeader eyebrow="Administrator" title="Membership Master List" description="The reference list of GAMLS IDs and Staff IDs for members in good standing. The ID a person enters when opening an account is checked against this list. Add, edit or delete single records, select several to delete, export the list or delete it all." />
      <div className="grid grid-cols-1 xl:grid-cols-[380px_1fr] gap-4 items-start">
        <MasterUpload meta={meta} onDone={() => setKey((k) => k + 1)} />
        <div className="min-w-0">
          <MasterEntries reloadKey={key} onChanged={() => setTick((k) => k + 1)} />
        </div>
      </div>
    </div>
  );
}
